export const AVATAR_SIZE = 512;

/**
 * Centre-crop a picked photo to a square JPEG of at most `size` pixels,
 * honouring EXIF orientation. Re-encoding also drops the original's
 * metadata (location), so a photo that cannot be decoded is refused
 * rather than uploaded as-is.
 */
export async function squareAvatar(file: Blob, size = AVATAR_SIZE): Promise<Blob> {
  const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
  try {
    const side = Math.min(bitmap.width, bitmap.height);
    const out = Math.min(size, side);
    const canvas = document.createElement("canvas");
    canvas.width = out;
    canvas.height = out;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("squareAvatar: no 2d canvas");
    ctx.drawImage(
      bitmap,
      (bitmap.width - side) / 2,
      (bitmap.height - side) / 2,
      side,
      side,
      0,
      0,
      out,
      out,
    );
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", 0.9),
    );
    if (!blob) throw new Error("squareAvatar: could not encode");
    return blob;
  } finally {
    bitmap.close();
  }
}
